import BrandSettingActionType from 'actions/brandSetting/brandSettingActionType';

const initialState = {
  loading: false,
  countriesData: null,
  main: {
    country: {},
    language: {},
    currency: {},
  },
  domains: null,
  sportDomains: null,
  generalSettings: {},
  captchaSettings: {},
  conversions: {
    deposits: null,
    withdrawals: null,
    others: null,
    conversion: {},
    logs: null,
  },
  standardSettings: {},
  restrictions: {
    blockedCountries: [],
    whitelistedIPs: null,
  },
  sportsBookLayouts: {},
  sportsBookLayoutsEndedStatus: false,
  sportsBookSettings: {},
  sportsBookWalletsSettings: {},
  casinoProductSettings: {},
  casinoProductJackpotSettings: {},
  casinoProductJackpotSettingsEndedStatus: false,
  casinoProductWalletsSettings: {},
  currencyFormat: {},
  inactivity: {},
  sportStatusSettings: null,
  nationalities: [],
  nationalitiesData: null,
  brandMobileCodes: null,
};

const brandSettingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case BrandSettingActionType.BRAND_SETTING_LOADER:
    return {
      ...state,
      loading: payload.loading,
    };
  case BrandSettingActionType.SAVE_BRAND_COUNTRIES_DATA:
    return {
      ...state,
      countriesData: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_COUNTRIES_DATA:
    return {
      ...state,
      countriesData: null,
    };
  case BrandSettingActionType.SET_BRAND_MAIN_SETTING:
    return {
      ...state,
      main: payload.data,
    };
  case BrandSettingActionType.SAVE_DOMAINS:
    return {
      ...state,
      domains: payload.data,
    };
  case BrandSettingActionType.RESET_DOMAINS:
    return {
      ...state,
      domains: null,
    };
  case BrandSettingActionType.SAVE_SPORT_DOMAINS:
    return {
      ...state,
      sportDomains: payload.data,
    };
  case BrandSettingActionType.RESET_SPORT_DOMAINS:
    return {
      ...state,
      sportDomains: null,
    };
  case BrandSettingActionType.SAVE_BRAND_GENERAL_SETTINGS:
    return {
      ...state,
      generalSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_CAPTCHA_SETTINGS:
    return {
      ...state,
      captchaSettings: {},
    };
  case BrandSettingActionType.SAVE_BRAND_CAPTCHA_SETTINGS:
    return {
      ...state,
      captchaSettings: payload.data,
    };
  case BrandSettingActionType.SAVE_BRAND_DEPOSIT_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        deposits: payload.data,
      },
    };
  case BrandSettingActionType.SAVE_BRAND_WITHDRAWAL_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        withdrawals: payload.data,
      },
    };
  case BrandSettingActionType.SAVE_BRAND_OTHER_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        others: payload.data,
      },
    };
  case BrandSettingActionType.RESET_BRAND_DEPOSIT_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        deposits: null,
      },
    };
  case BrandSettingActionType.RESET_BRAND_WITHDRAWAL_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        withdrawals: null,
      },
    };
  case BrandSettingActionType.RESET_BRAND_OTHER_CONVERSIONS:
    return {
      ...state,
      conversions: {
        ...state.conversion,
        others: null,
      },
    };
  case BrandSettingActionType.SAVE_BRAND_CONVERSION:
    return {
      ...state,
      conversions: {
        ...state.conversions,
        conversion: payload.data,
      },
    };
  case BrandSettingActionType.RESET_BRAND_CONVERSION:
    return {
      ...state,
      conversions: {
        ...state.conversions,
        conversion: {},
      },
    };
  case BrandSettingActionType.SAVE_BRAND_CONVERSION_LOGS:
    return {
      ...state,
      conversions: {
        ...state.conversions,
        logs: payload.data,
      },
    };
  case BrandSettingActionType.RESET_BRAND_CONVERSION_LOGS:
    return {
      ...state,
      conversions: {
        ...state.conversions,
        logs: null,
      },
    };
  case BrandSettingActionType.SAVE_BRAND_STANDARD_SETTINGS:
    return {
      ...state,
      standardSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_STANDARD_SETTINGS:
    return {
      ...state,
      standardSettings: {},
    };
  case BrandSettingActionType.SAVE_BRAND_BLOCKED_COUNTRIES: {
    return {
      ...state,
      restrictions: {
        ...state.restrictions,
        blockedCountries: payload.data,
      },
    };
  }
  case BrandSettingActionType.RESET_BRAND_BLOCKED_COUNTRIES: {
    return {
      ...state,
      restrictions: {
        ...state.restrictions,
        blockedCountries: [],
      },
    };
  }
  case BrandSettingActionType.SAVE_BRAND_WHITELISTED_IPS: {
    return {
      ...state,
      restrictions: {
        ...state.restrictions,
        whitelistedIPs: payload.data,
      },
    };
  }
  case BrandSettingActionType.RESET_BRAND_WHITELISTED_IPS: {
    return {
      ...state,
      restrictions: {
        ...state.restrictions,
        whitelistedIPs: null,
      },
    };
  }

  case BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_LAYOUTS:
    return {
      ...state,
      sportsBookLayouts: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_SPORTSBOOK_LAYOUTS:
    return {
      ...state,
      sportsBookLayouts: {},
    };
  case BrandSettingActionType.CHANGE_BRAND_SPORTSBOOK_LAYOUTS_CALL_ENDED_STATUS:
    return {
      ...state,
      sportsBookLayoutsEndedStatus: payload.status,
    };
  case BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_SETTINGS:
    return {
      ...state,
      sportsBookSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_SPORTSBOOK_SETTINGS:
    return {
      ...state,
      sportsBookSettings: {},
    };
  case BrandSettingActionType.RESET_BRAND_SETTINGS:
    return initialState;
  case BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_WALLETS_SETTINGS:
    return {
      ...state,
      sportsBookWalletsSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_SPORTSBOOK_WALLETS_SETTINGS:
    return {
      ...state,
      sportsBookWalletsSettings: {},
    };
  case BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS:
    return {
      ...state,
      casinoProductWalletsSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS:
    return {
      ...state,
      casinoProductWalletsSettings: {},
    };
  case BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_SETTINGS:
    return {
      ...state,
      casinoProductSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_SETTINGS:
    return {
      ...state,
      casinoProductSettings: {},
    };
  case BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS:
    return {
      ...state,
      casinoProductJackpotSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS:
    return {
      ...state,
      casinoProductJackpotSettings: {},
    };
  case BrandSettingActionType.CHANGE_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS_ENDED_STATUS:
    return {
      ...state,
      casinoProductJackpotSettingsEndedStatus: payload.status,
    };
  case BrandSettingActionType.SAVE_BRAND_CURRENCY_FORMAT:
    return {
      ...state,
      currencyFormat: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_CURRENCY_FORMAT:
    return {
      ...state,
      currencyFormat: {},
    };
  case BrandSettingActionType.SAVE_BRAND_INACTIVITY_SETTINGS:
    return {
      ...state,
      inactivity: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_INACTIVITY_SETTINGS:
    return {
      ...state,
      inactivity: {},
    };
  case BrandSettingActionType.SAVE_BRAND_SPORT_STATUS_SETTINGS:
    return {
      ...state,
      sportStatusSettings: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_SPORT_STATUS_SETTINGS:
    return {
      ...state,
      sportStatusSettings: null,
    };
  case BrandSettingActionType.SAVE_BRAND_NATIONALITIES:
    return {
      ...state,
      nationalities: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_NATIONALITIES:
    return {
      ...state,
      countries: [],
    };
  case BrandSettingActionType.SAVE_BRAND_NATIONALITIES_DATA:
    return {
      ...state,
      nationalitiesData: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_NATIONALITIES_DATA:
    return {
      ...state,
      nationalitiesData: null,
    };
  case BrandSettingActionType.SAVE_BRAND_MOBILE_CODES:
    return {
      ...state,
      brandMobileCodes: payload.data,
    };
  case BrandSettingActionType.RESET_BRAND_MOBILE_CODES:
    return {
      ...state,
      brandMobileCodes: null,
    };
  default:
    return state;
  }
};

export default brandSettingReducer;
